export default {
    Alerts: 'Alerts',
    Goal: 'Goal',
    Current: 'Current',
    Location: 'Location',
    Opens: 'Opens',
    Closes: 'Closes',
    OnDate: 'On Date',
    Share: 'Share',
    mapGO: 'Go',
    AddToCalendar: 'Add to calendar',
    SettingsPersonal: 'Personal',
    SettingsReminders: 'Reminders',
    SettingsHowToDonate: 'How-To-Donate',
    SettingsHelpAndSupport: 'Help & Support',
    SettingsContactUs: 'Contact Us',
    SettingsFAQ: 'FAQ',
    SettingsAbout: 'About',
    ReminderSettingsPhoneNotification: 'Would you like to recieve notifications to your phone?',
    Yes: 'Yes',
    No: 'No',
    Home: 'Home',
    Personal: 'Personal',
    Goals: 'Goals',
    Settings: 'Settings',
    Map:'Map',
    Date: "Date",
    Pulse: "Pulse",
    Pressure: "Pressure",
    Hemoglobin: "Hemoglobin",
    MapScreenTitle: "Blood Donation Spots & Centers",
    PersonalScreenTitle: "History Log",
    WhatIYourNames:"What is your name?",
    WhatIYourBloodType:"What is your blood type?",
    ChooseYourBloodType: "Choose your Blood Type",
    PersonalSettings: "Personal Settings",
    HowManyTimesDidYouDonateBlood: "How many times did you donate blood?",
    HowManyTimesWouldYouLikeToDonatePerYear: "How many times would you like to donate per year?",
    RemindersSettings: 'Reminders',
    SearchPlaceholder: 'Search...',
    Donations: 'Donations',
    Language: 'Language',
    MostRecentDonation: 'When was your most recent donation?',
    shareMessageTitle: "Hi, I thought you would like to know that you can donate blood near you at (1) on (2) - Thanks!",
    AddToCalendarTitle: 'Blood donation - Thanks!',
    AddToCalendarDescription: ' ',
    shareMessageBody: ' ',
    yourPersonalGoals:"Your Personal Goal"

}